/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error } from '../../../Shared/Components/Toast';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import { useEffect } from 'react';
import Loading from '../../../Shared/Components/Loading';
import SunTextEditor from '../../../Shared/Components/SunTextEditor';
import { number_format } from '../../../Shared/utils/helper';
import { useParams } from 'react-router';
import moment from 'jalali-moment';
import Status from './Status';

const validationSchema = Yup.object().shape({});

const ShowMatch = () => {
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState([]);
	const [, setMatchStyle] = useState([]);
	//One
	const [ages, setAges] = useState([]);
	const [provinces, setProvinces] = useState([]);
	const [, setAgeId] = useState('');
	const [price, setPrice] = useState('');
	const [, setAgeTitle] = useState('');
	const [, setProvinceId] = useState('');
	const [, setProvinceTitle] = useState('');
	const [errorAge] = useState(false);
	//Team (loaded for API parity; team section not rendered in this view)
	const [, setAgesTeam] = useState([]);
	const [, setProvincesTeam] = useState([]);
	//Double
	const [agesDouble, setAgesDouble] = useState([]);
	const [provincesDouble, setProvincesDouble] = useState([]);
	const [, setAgeIdDouble] = useState('');
	const [priceDouble, setPriceDouble] = useState('');
	const [, setAgeTitleDouble] = useState('');
	const [, setProvinceIdDouble] = useState('');
	const [, setProvinceTitleDouble] = useState('');
	const [errorAgeDouble] = useState(false);
	const [provinceCountDouble, setProvinceCountDouble] = useState('');
	//League
	const [agesLeague, setAgesLeague] = useState([]);
	const [provincesLeague, setProvincesLeague] = useState([]);
	const [, setAgeIdLeague] = useState('');
	const [priceLeague, setPriceLeague] = useState('');
	const [, setAgeTitleLeague] = useState('');
	const [, setProvinceIdLeague] = useState('');
	const [, setProvinceTitleLeague] = useState('');
	const [provinceCountLeague, setProvinceCountLeague] = useState('');
	const [provinceCountPersonLeague, setProvinceCountPersonLeague] = useState('');
	const [errorAgeLeague] = useState(false);

	useEffect(() => {
		getInfo();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const getInfo = async () => {
		setLoading(true);

		await useApi.get(
			'/panel/status',
			{},
			(res) => {
				eventContext.statuses = res.data.data;
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			'/panel/role?all=1',
			{},
			(res) => {
				eventContext.roles = res.data.data?.filter(
					(r) =>
						r.name === 'federation' ||
						r.name === 'zone' ||
						r.name === 'province board' ||
						r.name === 'club',
				);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);

		await useApi.get(
			`/panel/match/${id}`,
			{},
			(res) => {
				let match = res.data.data;
				eventContext.match = match;
				setAges(match.match_ages?.single ?? []);
				setAgesTeam(match.match_ages?.team ?? []);
				setAgesDouble(match.match_ages?.double ?? []);
				setAgesLeague(match.match_ages?.league ?? []);
				setProvinces(match.match_allowed_provinces?.single ?? []);
				setProvincesTeam(match.match_allowed_provinces?.team ?? []);
				setProvincesDouble(match.match_allowed_provinces?.double ?? []);
				setProvincesLeague(match.match_allowed_provinces?.league ?? []);
				setMatchStyle(eventContext.match?.match_style?.id);
				setType(match.match_kinds);
				setLoading(false);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
	};

	const onSubmitForm = async (values, setSubmitting) => {};

	return loading ? (
		<Loading />
	) : (
		<Master
			sidebarComponent={
				<Status
					statuses={eventContext.statuses}
					matchId={eventContext.match?.id}
					statusId={eventContext.match?.status?.id}
					roles={eventContext.roles}
					registerBy={eventContext.match?.register_by}
				/>
			}
			showFormSidebar={true}>
			<Formik
				initialValues={{
					title: eventContext.match?.title,
					match_style_id: eventContext.match?.match_style,
					match_kinds: eventContext.match?.match_kinds,
					province: eventContext.match?.province,
					city: eventContext.match?.city,
					register_start: moment(
						eventContext.match?.register_start ?? '1950-01-01',
						'YYYY-MM-DD  HH:mm:ss',
					)
						.locale('fa')
						.format('YYYY/MM/DD HH:mm:ss'),
					register_end: moment(
						eventContext.match?.register_end ?? '1950-01-01',
						'YYYY/MM/DD HH:mm:ss',
					)
						.locale('fa')
						.format('YYYY/MM/DD HH:mm:ss'),
					start: moment(eventContext.match?.start ?? '1950-01-01', 'YYYY-MM-DD')
						.locale('fa')
						.format('YYYY/MM/DD'),
					end: moment(eventContext.match?.end ?? '1950-01-01', 'YYYY-MM-DD')
						.locale('fa')
						.format('YYYY/MM/DD'),
					allowed_person: eventContext.match?.allowed_person,
					gender: eventContext.match?.gender,
					address: eventContext.match?.address,
					description: eventContext.match?.description,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان مسابقه</label>
										<input
											disabled={true}
											name='title'
											value={values.title}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.title} />
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>سبک برگزاری</label>
										<span className='form-control f-14 bg-gray'>
											{eventContext.match?.match_style?.title}
										</span>
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>نوع مسابقه</label>

										<span className='form-control f-14 bg-gray'>
											{eventContext.match?.match_kinds?.[0]?.name || '-'}
										</span>
										<ErrorMessage error={errors.match_kinds} />
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>استان محل برگزاری</label>

										<span className='form-control f-14 bg-gray'>
											{eventContext.match?.province?.name}
										</span>
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>شهر محل برگزاری</label>
										<span className='form-control f-14 bg-gray'>
											{eventContext.match?.city?.name}
										</span>
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>شروع ثبت نام</label>
										<span className='form-control f-14 bg-gray'>
											{moment(
												eventContext.match?.register_start ?? '1950-01-01',
												'YYYY-MM-DD  HH:mm:ss',
											)
												.locale('fa')
												.format('YYYY/MM/DD HH:mm:ss')}
										</span>
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>پایان ثبت نام</label>
										<span className='form-control f-14 bg-gray'>
											{moment(
												eventContext.match?.register_end ?? '1950-01-01',
												'YYYY-MM-DD  HH:mm:ss',
											)
												.locale('fa')
												.format('YYYY/MM/DD HH:mm:ss')}
										</span>
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>نوع ثبت‌نام</label>
										<span className='form-control f-14 bg-gray'>
											{eventContext.match?.registration_mode === 'reserve_list'
												? 'لیست رزرو'
												: 'عادی'}
										</span>
									</div>
								</div>
							</div>
							{eventContext.match?.registration_mode === 'reserve_list' && (
								<div className='col-12'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>لیست رزرو</label>
											<span className='form-control f-14 bg-gray'>
												{(eventContext.match?.reserve_national_codes || []).length}{' '}
												کد ملی
											</span>
										</div>
									</div>
								</div>
							)}
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>شروع برگزاری</label>
										<span className='form-control f-14 bg-gray'>
											{moment(
												eventContext.match?.start ?? '1950-01-01',
												'YYYY-MM-DD  HH:mm:ss',
											)
												.locale('fa')
												.format('YYYY/MM/DD HH:mm:ss')}
										</span>
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>پایان برگزاری</label>
										<span className='form-control f-14 bg-gray'>
											{moment(
												eventContext.match?.end ?? '1950-01-01',
												'YYYY-MM-DD  HH:mm:ss',
											)
												.locale('fa')
												.format('YYYY/MM/DD HH:mm:ss')}
										</span>
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>ظرفیت</label>
										<input
											disabled={true}
											name='allowed_person'
											value={values.allowed_person}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.allowed_person} />
									</div>
								</div>
							</div>

							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>جنسیت</label>
										<select
											disabled={true}
											className='form-control'
											name='gender'
											onChange={handleChange}
											value={values.gender}>
											<option>انتخاب کنید</option>
											<option value='1'>مرد</option>
											<option value='2'>زن</option>
											<option value='3'>مشترک</option>
										</select>
										<ErrorMessage error={errors.gender} />
									</div>
								</div>
							</div>
							{type.find((t) => t.name === 'انفرادی') !== undefined && (
								<>
									<div className='col-12'>
										<h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
											انفرادی
										</h1>
									</div>
									{eventContext.ages?.length > 0 || ages.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب رده سنی</label>
												<div className='d-flex flex-row justify-content-around'>
													<div className='d-flex flex-row'>
														<select
															disabled={true}
															id='select-age'
															className={`form-control ${
																errorAge && 'border-danger'
															}`}
															onChange={(e) => {
																let value = e.target.value.split('-');
																setAgeId(value?.[0]);
																setAgeTitle(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																رده سنی
															</option>
															{eventContext.ages?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.title}>
																	{item.title}
																</option>
															))}
														</select>
														<input
															disabled={true}
															onChange={(e) => setPrice(e.target.value)}
															type='text'
															value={price}
															placeholder='هزینه انفرادی (ریال)'
															className={`form-control mx-1 ${
																errorAge && 'border-danger'
															}`}
														/>
													</div>
												</div>
												{ages?.map((item) => (
													<div
														className='d-flex flex-row justify-content-around my-2'
														key={item.id}>
														<div className='d-flex flex-row'>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={item.title}
															/>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={number_format(item.person_price)}
															/>
														</div>
													</div>
												))}
											</div>
										</div>
									) : null}
									{eventContext.provinces?.length > 0 ||
									provinces.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب استان های مجاز </label>
												<div className='d-flex flex-row'>
													<div className='d-flex flex-row'>
														<select
															disabled={true}
															id='select-age-one'
															className='form-control'
															onChange={(e) => {
																let value = e.target.value.split('-');
																setProvinceId(value?.[0]);
																setProvinceTitle(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																انتخاب استان
															</option>

															{eventContext.provinces?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.name}>
																	{item.name}
																</option>
															))}
														</select>
													</div>
												</div>
												{provinces.length > 0 && (
													<div
														className='overflow-auto border border-info p-2 my-2 rounded'
														style={{ maxHeight: '200px' }}>
														{provinces?.map((item) => (
															<div
																className='d-flex flex-row my-2'
																key={item.id}>
																<div className='d-flex flex-row'>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.title}
																	/>
																</div>
															</div>
														))}
													</div>
												)}
											</div>
										</div>
									) : null}
								</>
							)}

							{type.find((t) => t.name === 'لیگ') !== undefined && (
								<>
									<div className='col-12'>
										<h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
											لیگ
										</h1>
									</div>
									{eventContext.ages?.length > 0 || agesLeague.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب رده سنی</label>
												<div className='d-flex flex-row justify-content-around'>
													<div className='d-flex flex-row'>
														<select
															disabled={true}
															id='select-age'
															className={`form-control ${
																errorAgeLeague && 'border-danger'
															}`}
															onChange={(e) => {
																let value = e.target.value.split('-');
																setAgeIdLeague(value?.[0]);
																setAgeTitleLeague(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																رده سنی
															</option>
															{eventContext.ages?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.title}>
																	{item.title}
																</option>
															))}
														</select>
														<input
															disabled={true}
															onChange={(e) => setPriceLeague(e.target.value)}
															type='text'
															value={priceLeague}
															placeholder='هزینه لیگ (ریال)'
															className={`form-control mx-1 ${
																errorAgeLeague && 'border-danger'
															}`}
														/>
													</div>
												</div>
												{agesLeague?.map((item) => (
													<div
														className='d-flex flex-row justify-content-around my-2'
														key={item.id}>
														<div className='d-flex flex-row'>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={item.title}
															/>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={number_format(item.person_price)}
															/>
														</div>
													</div>
												))}
											</div>
										</div>
									) : null}
									{eventContext.provinces?.length > 0 ||
									provincesLeague.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب استان های مجاز </label>
												<div className='d-flex flex-row'>
													<div className='d-flex flex-row justify-content-between'>
														<select
															disabled={true}
															id='select-age-league'
															className='form-control w-100'
															onChange={(e) => {
																let value = e.target.value.split('-');
																setProvinceIdLeague(value?.[0]);
																setProvinceTitleLeague(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																انتخاب استان
															</option>

															{eventContext.provinces?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.name}>
																	{item.name}
																</option>
															))}
														</select>
													</div>
													<input
														disabled={true}
														type='text'
														className='form-control w-30'
														onChange={(e) =>
															setProvinceCountLeague(e.target.value)
														}
														value={provinceCountLeague}
														placeholder='تعداد تیم'
													/>
													<input
														disabled={true}
														type='text'
														className='form-control w-30'
														onChange={(e) =>
															setProvinceCountPersonLeague(e.target.value)
														}
														value={provinceCountPersonLeague}
														placeholder='تعداد افراد تیم'
													/>
												</div>
												{provincesLeague.length > 0 && (
													<div
														className='overflow-auto border border-info p-2 my-2 rounded'
														style={{ maxHeight: '200px' }}>
														<div className='d-flex flex-row my-2 justify-content-around'>
															<label>استان</label>
															<label>تعداد تیم</label>
															<label>تعداد افراد تیم</label>
														</div>
														{provincesLeague?.map((item) => (
															<div
																className='d-flex flex-row my-2'
																key={item.id}>
																<div className='d-flex flex-row'>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.title}
																	/>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.province_count_league}
																	/>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.province_count_person_league}
																	/>
																</div>
															</div>
														))}
													</div>
												)}
											</div>
										</div>
									) : null}
								</>
							)}

							{type.find((t) => t.name === 'دوبل')
							 !== undefined && (
								<>
									<div className='col-12'>
										<h1 className='flex flex-column border-bottom pb-2 my-2 f-14'>
											دوبل
										</h1>
									</div>
									{eventContext.ages?.length > 0 || ages.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب رده سنی</label>
												<div className='d-flex flex-row justify-content-around'>
													<div className='d-flex flex-row'>
														<select
															disabled={true}
															id='select-age'
															className={`form-control ${
																errorAgeDouble && 'border-danger'
															}`}
															onChange={(e) => {
																let value = e.target.value.split('-');
																setAgeIdDouble(value?.[0]);
																setAgeTitleDouble(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																رده سنی
															</option>
															{eventContext.ages?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.title}>
																	{item.title}
																</option>
															))}
														</select>
														<input
															disabled={true}
															onChange={(e) => setPriceDouble(e.target.value)}
															type='text'
															value={priceDouble}
															placeholder='هزینه دوبل (ریال)'
															className={`form-control mx-1 ${
																errorAgeDouble && 'border-danger'
															}`}
														/>
													</div>
												</div>
												{agesDouble?.map((item) => (
													<div
														className='d-flex flex-row justify-content-around my-2'
														key={item.id}>
														<div className='d-flex flex-row'>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={item.title}
															/>
															<input
																disabled
																type='text'
																className='form-control mx-1'
																value={number_format(item.person_price)}
															/>
														</div>
													</div>
												))}
											</div>
										</div>
									) : null}
									{eventContext.provinces?.length > 0 ||
									provinceCountDouble.length > 0 ? (
										<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
											<div className='form-group'>
												<label>انتخاب استان های مجاز </label>
												<div className='d-flex flex-row'>
													<div className='d-flex flex-row'>
														<select
															disabled={true}
															id='select-age-double'
															className='form-control'
															onChange={(e) => {
																let value = e.target.value.split('-');
																setProvinceIdDouble(value?.[0]);
																setProvinceTitleDouble(value?.[1]);
															}}>
															<option selected={true} disabled={true}>
																انتخاب استان
															</option>

															{eventContext.provinces?.map((item) => (
																<option
																	key={item.id}
																	value={item.id + '-' + item.name}>
																	{item.name}
																</option>
															))}
														</select>
													</div>
													<input
														disabled={true}
														type='text'
														className='form-control w-30'
														onChange={(e) =>
															setProvinceCountDouble(e.target.value)
														}
														value={provinceCountDouble}
														placeholder='تعداد تیم'
													/>
													<input
														disabled={true}
														type='text'
														className='form-control w-30'
														value='2'
														placeholder='تعداد افراد تیم'
													/>
												</div>
												{provincesDouble.length > 0 && (
													<div
														className='overflow-auto border border-info p-2 my-2 rounded'
														style={{ maxHeight: '200px' }}>
														<div className='d-flex flex-row my-2 justify-content-around'>
															<label>استان</label>
															<label>تعداد تیم</label>
															<label>تعداد افراد تیم</label>
														</div>
														{provincesDouble?.map((item) => (
															<div
																className='d-flex flex-row my-2'
																key={item.id}>
																<div className='d-flex flex-row'>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.title}
																	/>

																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.province_count_double}
																	/>
																	<input
																		disabled
																		type='text'
																		className='form-control mx-1'
																		value={item.province_count_person_double}
																	/>
																</div>
															</div>
														))}
													</div>
												)}
											</div>
										</div>
									) : null}
								</>
							)}

							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>آدرس محل برگزاری</label>
										<textarea
											disabled={true}
											className='form-control'
											name='address'
											value={values.address}
											onChange={handleChange}></textarea>
										<ErrorMessage error={errors.address} />
									</div>
								</div>
							</div>

							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>توضیحات</label>
										<SunTextEditor handelChange={setFieldValue} />
										<ErrorMessage error={errors.description} />
									</div>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default ShowMatch;
